import BaseRepo from '../../BaseRepo';
import { ApiResponseAsync } from '../../models';
import { IExternalFormsRepo } from './IExternalForms';
import { ExternalFormValidated } from './typing';

export class ExternalFormsRepo extends BaseRepo implements IExternalFormsRepo {
  getExternalForm = (ott: string): ApiResponseAsync<ExternalFormValidated> => {
    const link = `/external-form/validate?ott=${encodeURIComponent(ott)}`;

    return this.helpers.handleGet(link, {
      responseStopTransformPaths: ['params'],
    });
  };
}
